import { html, property } from 'lit-element';
import { KatLitElement, register } from '../../shared/base';
import baseStyles from '../../shared/base/base.lit.scss';
import styles from './description-list.lit.scss';

/**
 * @component {kat-description-list} KatDescriptionList The Description List component provides a wrapper for HTML’s <code>dl</code> element to provide a few simple layout variations.
 * @example Default { "content": "<dt>Default Term 1</dt><dd>Default Description 1</dd><dt>Default Term 2</dt><dd>Default Description 2</dd><dt>Default Term 3</dt><dd>Default Description 3</dd>" }
 * @example Vertical { "vertical": true, "content": "<dt>Vertical Term 1</dt><dd>Vertical Description 1</dd><dt>Vertical Term 2</dt><dd>Vertical Description 2</dd><dt>Vertical Term 3</dt><dd>Vertical Description 3</dd>" }
 * @example Multiple { "content": "<dt>Multiple Term 1</dt><dd>Multiple Description 1</dd><dd>Multiple Description 2</dd><dd>Multiple Description 3</dd><dt>Multiple Term 2</dt><dt>Multiple Term 3</dt><dd>Multiple Description 4</dd>" }
 * @a11y {keyboard}
 * @a11y {contrast}
 * @a11y {sr}
 */
@register('kat-description-list')
export class KatDescriptionList extends KatLitElement {
  static get styles() {
    return [baseStyles, styles];
  }

  /** Display the description list vertically. */
  @property()
  vertical?: boolean = false;

  render() {
    return html`<dl><slot></slot></dl>`;
  }
}
